var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container flex-column flex-center"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.homeIcon,"alt":""}}),_c('p',{staticClass:"text"},[_vm._v("欢迎来到后端管理系统")])])
}
var staticRenderFns = []

export { render, staticRenderFns }